import { Checkbox } from '@airbus/components-react';
import BulkUpdateInputRenderer, {
  type BulkAttributeConfig,
  type BulkAttributeState,
  type BulkAttributeValue,
} from './BulkUpdateInputRenderer';
import styles from './BulkUpdateDialog.module.css';

type BulkUpdateAttributeRowProps = {
  attribute: BulkAttributeConfig;
  state: BulkAttributeState;
  language: string;
  onAttributeCheckboxToggle: (attribute: BulkAttributeConfig, checked: boolean) => void;
  onValueChange: (attribute: BulkAttributeConfig, value: BulkAttributeValue) => void;
};

function getLocalizedLabel(attribute: BulkAttributeConfig, language: string) {
  return language === 'de' ? attribute.attrDisplayNamede : attribute.attrDisplayNameen;
}

export default function BulkUpdateAttributeRow({
  attribute,
  state,
  language,
  onAttributeCheckboxToggle,
  onValueChange,
}: BulkUpdateAttributeRowProps) {
  const label = getLocalizedLabel(attribute, language);

  return (
    <div className={styles.attributeRow} key={attribute.attrInternalName}>
      <Checkbox
        checked={state.enabled}
        onChange={(event) => onAttributeCheckboxToggle(attribute, event.target.checked)}
        aria-label={`${label} checkbox`}
      />
      <div
        className={
          state.enabled
            ? styles.attributeLabel
            : `${styles.attributeLabel} ${styles.attributeLabelDisabled}`
        }
      >
        {label}
      </div>
      <div className={styles.inputCell}>
        <BulkUpdateInputRenderer
          attribute={attribute}
          state={state}
          onChange={(value) => onValueChange(attribute, value)}
        />
      </div>
    </div>
  );
}
